import { connect } from 'react-redux';
import LearningsAdminScreen from '../components/LearningsAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const LearningsAdminScreenContainer =
  connect(mapStateToProps)(LearningsAdminScreen);

export default LearningsAdminScreenContainer;
